'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';

const getI18nKey = path => `designComponents.errorPages.403.${path}`;

export default function AccessErrorPage() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "keys",
    illustrationProps: {
      width: 200
    },
    title: text(getI18nKey('header')),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(UILink, {
        href: `/dashboard/${PortalIdParser.get()}`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('dashboardLink')
        })
      })
    })
  });
}